import { PayloadAction } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'
import {
  all, call, put, select, takeLatest,
} from 'redux-saga/effects'
import { actions as appActions } from '../state'
import { ReturnCall } from '../types'
import apis from './StockAddressingInBatchApi'
import { selectAddressing } from './StockAddressingInBatchSelectors'
import { actions } from './StockAddressingInBatchState'
import {
  ErrorTypes, StockAddressing, StockAddressingStatus, SubmitFileValues,
} from './StockAddressingInBatchTypes'

const FILE_UPLOAD_ERROR_MESSAGE = 'Falha ao enviar a planilha de endereçamento'

function* submitStockAddressingFile(data: PayloadAction<SubmitFileValues>) {
  yield put(appActions.isLoading(true))
  yield put(actions.resetUploadPage())

  const { file, salesChannels } = data.payload

  const result: ReturnCall<typeof apis.postStockAddressingFile> = yield call(
    apis.postStockAddressingFile,
    file,
    salesChannels,
  )

  yield put(appActions.isLoading(false))

  if (!result.isOk && result.type === ErrorTypes.INVALID_STRUCTURE) {
    toast.error(FILE_UPLOAD_ERROR_MESSAGE)
    yield put(actions.setFileInvalidStructure(result.data))
    return
  }

  if (!result.isOk && result.type === ErrorTypes.FAILED_UPLOAD) {
    toast.error(`${FILE_UPLOAD_ERROR_MESSAGE}: ${result.data.message}`)
    return
  }

  yield put(actions.setStockAddressingResult(result.data))

  if (result.data?.status === StockAddressingStatus.INVALID) {
    toast.error('Falha ao processar. Faça download do arquivo!')
    return
  }

  toast.success('Arquivo enviado com sucesso!')
}

function* getSalesChannelsByFC(data: PayloadAction<number>) {
  yield put(appActions.isLoading(true))

  const result: ReturnCall<typeof apis.getSalesChannels> = yield call(
    apis.getSalesChannels,
    { fulfillmentCenterId: data.payload },
  )

  yield put(appActions.isLoading(false))

  if (!result.isOk) {
    toast.error(result.data.message)
    return
  }

  yield put(actions.setSalesChannelsByFC(result.data))
}

function* downloadAddressingResultFile() {
  yield put(appActions.isLoading(true))
  const adjustment: StockAddressing = yield select(selectAddressing)

  try {
    yield call(apis.getAddressingCsvFile, adjustment.id)
  } catch (error: any) {
    toast.error(`Falha ao fazer download do resultado de ajustes: ${error?.response?.data?.message ?? error.message}`)
  } finally {
    yield put(appActions.isLoading(false))
  }
}

export default function* () {
  yield all([
    takeLatest(actions.submitStockAddressingFile.type, submitStockAddressingFile),
    takeLatest(actions.getSalesChannelsByFC.type, getSalesChannelsByFC),
    takeLatest(actions.downloadAddressingResultFile.type, downloadAddressingResultFile),
  ])
}
